<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Panel</p>
      </sidebar-link>

      <sidebar-link to="/admin/fromMails">
        <i class="nc-icon nc-notes"></i>
        <p>Hesaplarım</p>
      </sidebar-link>

      <sidebar-link to="/admin/mails">
        <i class="nc-icon nc-email-83"></i>
        <p>Müşteri Mailleri</p>
      </sidebar-link>

      <sidebar-link to="/admin/mailgroups">
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Mail Grupları</p>
      </sidebar-link>

      <sidebar-link to="/admin/mailtemplates">
        <i class="nc-icon nc-paper-2"></i>
        <p>Mail Taslakları</p>
      </sidebar-link>

      <sidebar-link to="/admin/mailqueues">
        <i class="nc-icon nc-cloud-download-93"></i>
        <p>Mail Kuyrukları</p>
      </sidebar-link>

      <sidebar-link to="/admin/mailsend">
        <i class="nc-icon nc-send"></i>
        <p>Gönderilenler</p>
      </sidebar-link>

      <sidebar-link to="/admin/mailsendcreate">
        <i class="nc-icon nc-send"></i>
        <p>Yeni Mail Gönder</p>
      </sidebar-link>

      <sidebar-link to="/admin/categories">
        <i class="nc-icon nc-layers-3"></i>
        <p>Kategoriler</p>
      </sidebar-link>

      <sidebar-link to="/admin/items">
        <i class="nc-icon nc-app"></i>
        <p>Ürünler</p>
      </sidebar-link>

      <sidebar-link to="/admin/companies">
        <i class="nc-icon nc-badge"></i>
        <p>Şirketler</p>
      </sidebar-link>

      <sidebar-link to="/admin/settings">
        <i class="nc-icon nc-settings-tool-66"></i>
        <p>Sistem Ayarları</p>
      </sidebar-link>


    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
